import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ThemeState {
  theme: 'light' | 'dark'
  mode: 'light' | 'dark' // 保持向后兼容
  primaryColor: string
  secondaryColor: string
}

const initialState: ThemeState = {
  theme: 'light', // 默认日间模式
  mode: 'light', // 保持向后兼容
  primaryColor: '#3b82f6',
  secondaryColor: '#1e40af',
}

const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.theme = state.theme === 'light' ? 'dark' : 'light'
      state.mode = state.theme // 保持向后兼容
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.theme = action.payload
      state.mode = action.payload // 保持向后兼容
    },
    setPrimaryColor: (state, action: PayloadAction<string>) => {
      state.primaryColor = action.payload
    },
    setSecondaryColor: (state, action: PayloadAction<string>) => {
      state.secondaryColor = action.payload
    },
  },
})

export const { toggleTheme, setTheme, setPrimaryColor, setSecondaryColor } = themeSlice.actions
export default themeSlice.reducer